export const EMPTY_FILTER_STATE = { value: null, isActive: false, activeSince: null };

export const getActiveFilters = (filters) =>
  filters.filter(f => f.isActive && f.value !== null);

export const normalizeFiltersForComparison = (filters) =>
  JSON.stringify(filters.map(({ key, value, operator }) => ({ key, value, operator })));

export const filtersAreEqual = (filters1, filters2) =>
  normalizeFiltersForComparison(filters1) === normalizeFiltersForComparison(filters2);

export const clearFilter = (filter) => ({ ...filter, ...EMPTY_FILTER_STATE });

const isOfferedOperator = (filter, operator) =>
  !filter.operatorOptions || filter.operatorOptions.some(option => option.key === operator);

export const applyParsedFilter = (filter, parsedFilters) => {
  const matchedFilter = parsedFilters.find(pf => pf.key === filter.key);
  if (matchedFilter) {
    return {
      ...filter,
      value: matchedFilter.value,
      operator: isOfferedOperator(filter, matchedFilter.operator) ? matchedFilter.operator : filter.operator,
      isActive: true,
      activeSince: matchedFilter.activeSince
    };
  }
  return clearFilter(filter);
};

